var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForklift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 91,
    viewBox: "0 0 137 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2248 39.0215L68.1864 56.8118L59.5928 55.1009L66.4921 31.72L74.3932 36.5295C75.2248 37.0502 75.571 38.0916 75.2248 39.0215Z",
    fill: "#40596B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4971 42.9244V40.1752C87.4971 38.8331 88.5761 37.7323 89.9299 37.6954L101.032 37.3776C101.032 37.3776 98.0211 28.6333 102.186 23.5461C102.804 22.7914 103.797 22.4282 104.759 22.6155C106.187 22.8879 107.117 24.2554 106.839 25.674L103.88 40.5156L87.4971 42.9244Z",
    fill: "#FF7058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.965 2.48561C110.782 1.06445 109.568 0 108.131 0H83.9542C78.0698 0 72.8825 3.86397 71.2057 9.50012L58.3315 52.7087H61.9536L74.5335 10.4875C75.7646 6.35243 79.6409 3.47015 83.9599 3.47015H107.592L112.53 41.3108H116.032L110.965 2.48561Z",
    fill: "#CDD6E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5727 28.0258C81.0308 27.4803 80.157 27.4803 79.6151 28.0258L71.1011 36.6423C72.0714 36.9725 72.8147 37.5755 73.331 38.3478L81.5727 30.0098C82.1146 29.4586 82.1146 28.5742 81.5727 28.0258Z",
    fill: "#40596B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7231 26.0388L83.5563 31.8778L77.7231 26.0388Z",
    fill: "#40596B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5634 30.9081L78.6875 25.0294C78.1426 24.4814 77.2565 24.4814 76.7145 25.0294C76.1668 25.5716 76.1668 26.4582 76.7145 27.0062L82.5876 32.8848C82.8629 33.1603 83.2185 33.298 83.577 33.298C83.9354 33.298 84.2939 33.1603 84.5663 32.8848C85.1112 32.3397 85.1112 31.4589 84.5634 30.9081Z",
    fill: "#40596B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7098 2.05176H45.0884V63.9134H51.7098V2.05176Z",
    fill: "#40596B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3969 2.05176V68.2475L0 75.5607V78.1163H40.5167V2.05176H35.3969Z",
    fill: "#40596B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137 80.4833C137 74.1353 137 52.9752 137 46.0932C137 42.0211 133.728 38.7514 129.657 38.6857C116.927 38.4744 110.12 39.7965 93.8243 41.8212C90.6519 42.2209 88.2612 44.9052 88.2612 48.1064L79.9022 51.7758H54.8624C49.4647 51.7758 45.0884 56.1563 45.0884 61.5649V80.4833H137Z",
    fill: "#FFD15C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.2 56.9697L88.1156 68.9999H76.0699L64.4805 80.4835H136.843V56.9697H117.2Z",
    fill: "#F8B64C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.654 38.6636C111.455 38.9101 98.7729 40.0909 85.2892 41.7791C82.1372 42.1746 79.7725 44.8831 79.7725 48.0731V51.7618C86.8409 51.7618 93.841 50.389 100.393 47.7263L122.654 38.6636Z",
    fill: "#F8B64C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2588 77.7213C71.2588 84.909 65.4352 90.7406 58.251 90.7406C51.0697 90.7406 45.2461 84.909 45.2461 77.7213C45.2461 70.5336 51.0697 64.7019 58.251 64.7019C65.4352 64.6991 71.2588 70.5307 71.2588 77.7213Z",
    fill: "#40596B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6375 77.7219C64.6375 81.2487 61.7781 84.1132 58.2512 84.1132C54.7299 84.1132 51.8677 81.2516 51.8677 77.7219C51.8677 74.1922 54.7271 71.3306 58.2512 71.3306C61.7781 71.3306 64.6375 74.1922 64.6375 77.7219Z",
    fill: "#CDD6E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.487 77.7213C128.487 84.909 122.664 90.7406 115.481 90.7406C108.298 90.7406 102.475 84.909 102.475 77.7213C102.475 70.5336 108.298 64.7019 115.481 64.7019C122.664 64.7019 128.487 70.5307 128.487 77.7213Z",
    fill: "#40596B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.865 77.7219C121.865 81.2487 119.006 84.1132 115.48 84.1132C111.954 84.1132 109.095 81.2516 109.095 77.7219C109.095 74.1922 111.954 71.3306 115.48 71.3306C119.006 71.3306 121.865 74.1922 121.865 77.7219Z",
    fill: "#CDD6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForklift);
export default __webpack_public_path__ + "static/media/forklift.08db69de66f242e6ed56ab69b2c00c5f.svg";
export { ForwardRef as ReactComponent };